export default __webpack_public_path__ + "static/media/folding-box-section.76e85789.png";